import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FaBook } from 'react-icons/fa'
import { IoMusicalNotes } from 'react-icons/io5'

const HomeMenu = () => {
  const navigate = useNavigate()

  return (
    <>
      <div className="home-menu-grid">
        <div className="home-menu-item" onClick={() => navigate(`/artists`)}>
          <span className="home-menu-item-icon" aria-hidden>
            <IoMusicalNotes />
          </span>
          <h3>Musik</h3>
        </div>
        <div className="home-menu-item" onClick={() => navigate(`/books`)}>
          <span className="home-menu-item-icon" aria-hidden>
            <FaBook />
          </span>
          <h3>Böcker</h3>
        </div>
      </div>
    </>
  )
}

export default HomeMenu
